import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-up-medium, dropdown, caret"><path d="M17.2498 15C17.5413 14.9999 17.8064 14.8306 17.9295 14.5664C18.0524 14.3022 18.0114 13.9907 17.824 13.7676L12.574 7.51758C12.4316 7.34801 12.2213 7.25005 11.9998 7.25C11.7783 7.25 11.5681 7.34801 11.4256 7.51758L6.1756 13.7676C5.98815 13.9907 5.94714 14.3022 6.07013 14.5664C6.19329 14.8306 6.4583 15 6.74982 15H17.2498Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleUpMedium;
